import React from 'react';
import { Form } from 'antd';
import { KBButton, KBUserInput } from
'components';

const usersToValue = users =>
  users && users.length ? users.map(user => user.id).join(',') : '';
const getChangeValue = value => (value && value.target ? value.target.value : value);
const valueToUserIds = value => {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter(id => !!id);
  }
  return String(value).split(',').filter(id => !!id);
};

function FormField({ children, error, onChange, onClearError, touched, value }) {
  return children({
    value,
    touched,
    error,
    onChange: nextValue => {
      onChange(getChangeValue(nextValue));
      onClearError();
    }
  });
}

const buildInitialValues = fields =>
  fields.reduce((values, field) => {
    values[field.name] = usersToValue(field.selectedUsers);
    return values;
  }, {});

function LocationRoleUsersForm({ fields, users, updateLocation }) {
  const [form] = Form.useForm();
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(() => buildInitialValues(fields), [fields]);
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
    setErrors({});
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField
        error={errors[name]}
        touched={!!errors[name]}
        onClearError={() =>
          setErrors(prevErrors => Object.assign({}, prevErrors, { [name]: undefined }))
        }
      >
        {render}
      </FormField>
    </Form.Item>
  );

  const handleFinish = () => {
    const formValues = form.getFieldsValue();
    const nextErrors = fields.reduce((result, field) => {
      if (field.requiredMessage && !formValues[field.name]) {
        result[field.name] = field.requiredMessage;
      }
      return result;
    }, {});

    if (Object.keys(nextErrors).some(name => !!nextErrors[name])) {
      setErrors(nextErrors);
      return;
    }

    const roles = fields.map(field => {
      const value = formValues[field.name];
      return {
        role: field.role,
        range: field.range || 'all',
        user_ids: valueToUserIds(value)
      };
    });

    setSubmitting(true);
    const result = updateLocation({ roles });
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        error => {
          setSubmitting(false);
          throw error;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  return (
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <div>
        {fields.map(field => (
          <div className="kb-row" key={field.name}>
            {renderField(field.name, formField => (
              <KBUserInput
                field={formField}
                title={field.title}
                className="kb-form-group kb-form-c18 kb-form-alone"
                hint={field.hint}
                multi={field.multi !== false}
                users={users}
                selectedUsers={field.selectedUsers || []}
              />
            ))}
          </div>
        ))}
        <div className="kb-row">
          <KBButton className="certain-btn" type="submit" submitting={submitting}>
            确定修改
          </KBButton>
        </div>
      </div>
    </Form>
  );
}

export default LocationRoleUsersForm;
